import React, { Fragment, ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { Mobile, NotMobile } from "../../../../hocs/Responsive";
import { Icon } from "../../../icon/Icon";
import { LoadError } from "../../LoadError";

import "./WidgetSummary.scss";

interface ErrorSummaryProps {
  header: ReactNode;
  icon: string;
  onRefreshClick: () => void;
}

export const WidgetErrorSummary = ({
  header,
  icon,
  onRefreshClick,
}: ErrorSummaryProps) => {
  return (
    <Fragment>
      <span className="sr-only">
        <FormattedMessage id={"aria_widget_error"} />
      </span>
      <Mobile>
        <div className={"widget__header"} aria-hidden={true}>
          <div className="widget__title">{header}</div>
          <div className="widget__count">
            <FormattedMessage id={"not_applicable"} />
          </div>
        </div>
      </Mobile>
      <NotMobile>
        <div className="widget__count" aria-hidden={true}>
          <Icon icon={`fa-regular fa-${icon}`} />
          <span>
            <FormattedMessage id={"not_applicable"} />
          </span>
        </div>
        <div className="widget__title">{header}</div>
      </NotMobile>
      <LoadError
        onRefreshClick={onRefreshClick}
        className={"widget-data-error-container"}
      />
    </Fragment>
  );
};
